import React from "react";
import MasterDetailLayout from "../../../../components/layout/MasterDetailLayout";
import EnquiryCompactList from "../components/EnquiryCompactList";

const EnquirySplitView = () => <MasterDetailLayout list={<EnquiryCompactList />} />;

export default EnquirySplitView;
